// extracted by mini-css-extract-plugin
export default {"accordionContainer":"AccordionPanel-module__accordionContainer___1gwZh","clubAccordion":"AccordionPanel-module__clubAccordion___4JI5p"};